<div class="event-name" *ngIf="!isNewEDPScoreboard; else participantInfo">
    <ms-favourite-event-toggle class="participant-favourite" [event]="event"> </ms-favourite-event-toggle>
    <span class="participant-name">{{ event.name }} </span>
</div>
<div class="event-time">
    <div class="date" *ngIf="showDate">{{ showDate }} <span *ngIf="!isNewEDPScoreboard"> • </span> {{ event.startDate | date: 'shortTime' }}</div>
</div>
<ng-template #participantInfo>
    <div class="participant-info">
        <ms-competition-logo
            *ngIf="showCompetitionLogo; else defaultImage"
            [sportId]="event.sport.id"
            [leagueId]="event.league.id"
            [imageProfile]="event.league.imageProfile"></ms-competition-logo>
        <ng-template #defaultImage>
            <ms-participant-image
                class="participant-image"
                [participantImage]="event.league.imageProfile"
                [sportId]="event.sport.id"
                [showFallback]="isNewEDPScoreboard">
            </ms-participant-image>
        </ng-template>

        <div class="participant-name">
            {{ event.name }}
            <span class="participant-country">{{ event.league.name }}</span>
        </div>
    </div>
</ng-template>
